import {
  MILLISECONDS_IN_DAY,
  MILLISECONDS_IN_HOUR,
  MILLISECONDS_IN_MINUTE,
  MILLISECONDS_IN_SECOND,
} from "common";

export const msToDHMS = (ms: number) => {
  const days = Math.floor(ms / MILLISECONDS_IN_DAY);
  const msOfHoursLeft = Math.max(ms - days * MILLISECONDS_IN_DAY, 0);
  const hours = Math.floor(msOfHoursLeft / MILLISECONDS_IN_HOUR);
  const msOfMinutesLeft = Math.max(
    msOfHoursLeft - hours * MILLISECONDS_IN_HOUR,
    0
  );
  const minutes = Math.floor(msOfMinutesLeft / MILLISECONDS_IN_MINUTE);
  const msOfSecondsLeft = Math.max(
    msOfMinutesLeft - minutes * MILLISECONDS_IN_MINUTE,
    0
  );
  const seconds = Math.floor(msOfSecondsLeft / MILLISECONDS_IN_SECOND);
  return {
    d: days,
    h: hours,
    m: minutes,
    s: seconds,
  };
};

export const getStartOfDay = (unix: number) => {
  const date = new Date(unix);
  const startOfDay = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate()
  );
  return startOfDay.getTime();
};

/**
 * Get the unix date time of start of today
 */
export const getStartOfToday = () => {
  return getStartOfDay(Date.now());
};

export const get12HrTime = (unix: number) => {
  const date = new Date(unix);
  return date.toLocaleString("en-US", {
    hour: "numeric",
    hour12: true,
    minute: "numeric",
  });
};

export const DAYS_OF_WEEK_SHORT = [
  "Sun",
  "Mon",
  "Tue",
  "Wed",
  "Thu",
  "Fri",
  "Sat",
];
